import React from 'react';
import Login from '../components/Login';

// The page renders its own public nav now (see v2/auth/AuthShell), so the v1 Navbar that
// used to sit above it would be a second, differently-styled header on the same screen.
function LLogin() {
  return <Login />;
}

export default LLogin;
